<template>
    <el-dialog custom-class="notice-editor-dislog" :visible.sync="openDialog" width="1142px" top="20px" :title="title"  :close-on-click-modal="false">
        <el-form label-width="80px" label-position="top" ref="form" :model="form" :rules="rules" size="small">
            <el-row :gutter="10">
                <el-col :span="isprivapo?24:12">
                    <el-form-item label="公告标题：" prop="title">
                        <el-input v-model="form.title" placeholder="请输入公告标题"/>
                    </el-form-item>
                </el-col>
                <el-col :span="6" v-if="!isprivapo">
                    <el-form-item label="公告类型：" prop="noticeType">
                        <el-select v-model="form.noticeType" style="width: 100%" placeholder="请选择公告类型">
                            <el-option v-for="item in noticeType" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4" :offset="2" v-if="!isprivapo">
                    <el-form-item label="是否发布到门户：" prop="publicHomePage">
                        <el-radio-group v-model="form.publicHomePage">
                            <el-radio label="是">是</el-radio>
                            <el-radio label="否">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="公告内容1：" prop="content">
                        <!-- <QuillEditor v-if="openDialog" editHeight="500" /> -->
                        <WangEditor v-if="openDialog" ref="WangEditorRef" @callback="WangEditorCallback" :content="form.content" editHeight="500" />
                    </el-form-item>
                </el-col>
                <el-col :span="24" v-if="!isprivapo">
                    <el-form-item label="附件：" prop="noticeFileList">
                        <div class="file-list-box">
                            <div class="file-item" v-for="item in form.noticeFileList" :key='item.fileUrl'>
                                <div><span>{{item.fileName}}</span><i class="el-icon-delete del" @click="delFile(item)"></i></div>
                            </div>
                        </div>

                        <el-upload class="upload-demo" :action="upload()" :show-file-list="false"
                            accept=".xls,.xlsx,.doc,.docx,.pdf,application/msword" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload" :headers="{'Authentication':token()}">
                            <!-- <el-input style="width:100%" v-model="form.fileUrl" placeholder="点击文本框上传" readonly slot="trigger" /> -->
                            <el-button type="primary" slot="trigger" size="small">添加附件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import QuillEditor from '../../../components/QuillEditor.vue'
import WangEditor from '../../../components/WangEditor.vue'
import { addNotice,editNotice } from '@/api/notice.js';
import { noticeType } from '../../../utils/dict'
export default {
     components: {
        QuillEditor,WangEditor
    },
    computed: {
        currencyInfo:function(){
            return this.$store.getters['app/currencyInfo'];
        },
    },
    data(){
        return {
            isprivapo:false,
            noticeType,
            title: "",
            openDialog: false,
            form: {
                id:'',
                title:'',
                noticeType:'',
                content:'',
                noticeFileList:[],
                publicHomePage:'否',
            },
            rules: {
                title: [{
                    required: true,
                    message: '请输入公告标题',
                    trigger: 'blur'
                }],
                noticeType: [{
                    required: true,
                    message: '请选择公告类型',
                    trigger: 'blur'
                }],
                 content: [{
                    required: true,
                    message: '请输入公告内容',
                    trigger: 'blur'
                }],
            }
        }
    },
    methods:{
        openDialogFun(row,title){
            this.title = title;
            this.reset();
            if(row){
                this.form={
                    id:row.id,
                    title:row.title,
                    noticeType:row.noticeType+'',
                    content:row.content,
                    // content:'09090909090',
                    noticeFileList:row.noticeFileList,
                    publicHomePage:row.publicHomePage
                }
            }
            // console.log(this.form.content)
            this.openDialog = true;
            this.$nextTick(()=>{
                this.$refs.WangEditorRef.init(this.form.content)
            })
        },
         // 表单重置
        reset: function () {
            this.form = {
                id: undefined,
                title:'',
                noticeType:'',
                publicHomePage:'否',
                content:'',
                noticeFileList:[
                    // {
                    //     fileName:'',
                    //     fileUrl:''
                    // }, {
                    //     baseName:'',
                    //     fileUrl:''
                    // },
                ],
            }
            if (this.$refs["form"] !== undefined) {
                this.$refs["form"].resetFields();
            }
        },
        submitForm() {
            let _this = this;
            _this.form.content = _this.$refs.WangEditorRef.editorData;
            // console.log(_this.$refs.WangEditorRef.editorData)
            // 测试用
            // let testData = {
            //     title:this.form.title,
            //     body:this.form.content,
            //     createdDate:'2021-11-14 18:22:23',
            //     author:'张小娴',
            // };
            // localStorage.setItem('editorTest',JSON.stringify(testData));
            // _this.openDialog = false;
            // return
            _this.$refs['form'].validate((valid) => {
                if (valid) {
                    let newForm = {
                        // userName:this.$store.getters['user/user'],
                        status:0,
                        createUser: this.$store.getters['user/user'].id,
                        ..._this.form
                    }
                    if(_this.isprivapo){
                        _this.$emit('callback',{type:'addprivapo',info:newForm})
                        return
                    }
                    if (_this.form.id) {
                        editNotice(newForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    } else {
                        delete newForm.id
                        addNotice(newForm).then(response => {
                            if (response.data.code === 0) {
                                _this.$success(response.data.msg);
                                _this.openDialog = false;
                                _this.$emit('callback',{type:'getlist'})
                            } else {
                                _this.$fail(response.data.msg);
                            }
                        });
                    }
                }
            });
        },
        handleAvatarSuccess(res, file) {
            if (res.code == 0) {
                this.$success(res.msg);
                this.form.noticeFileList.push({
                    fileName:res.data.baseName,
                    fileUrl:res.data.url,
                });
            }
        },
        beforeAvatarUpload(file) {
            let sizeNum = 10;
            const size = file.size / 1024 / 1024 < sizeNum;
            if (!size) {
                this.$fail(`上传附件大小不能超过 ${sizeNum}MB!`);
            }
            return size;
        },
        delFile(item){
            if(this.form.id){   // 编辑
                let files = [...this.form.noticeFileList];
                let newFiles = [];
                files.forEach((it)=>{
                    if(ie.url != item.url){
                        newFiles.push(it)
                    }
                })
                this.form.noticeFileList = newFiles;
            }else{  // 删除
                this.delFile(item.url);
            }
        },
        WangEditorCallback(obj){
            if(obj.type == 'editorContent'){
                this.form.content = obj.value;
                this.$refs.form.validateField('content');
            }
        }
    },
}
</script>
<style lang="scss">
.notice-editor-dislog{
    .file-item{
        width: 100%;
        font-size: 14px;
        color: #333;
        overflow: hidden;
        div{
            line-height: 32px;
            height: 32px;
            float: left;
            border-bottom: 1px solid #efefef;
            display: flex;
            .del{
                margin-left: 20px;
                font-size: 16px;
                line-height: 32px;
                color: red;
                cursor: pointer;
            }
        }
    }
    .el-upload{
        margin-top: 10px;
        text-align: left;
    }
    .file-list-box{
        width: 100%;
        max-height: 130px;
        overflow-y: auto;
    }
}
</style>


